import styled from 'styled-components';
import { TrendEnum } from '../../../../constants/budgetPlanned';
import { Typography } from '../../../../stories/atoms';

export const IndexTypography = styled(Typography)<{ trend: TrendEnum }>`
  color: ${({ theme: { color }, trend }) => (trend === TrendEnum.UP ? color.validationGreen : color.red)};
`;
